

export const HowToUseSection = () => {
    return (
        <section id="hoe-het-werkt" className="bg-surface-100 py-16 lg:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <span className="inline-block rounded-full bg-brand-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-700">
                        In 3 stappen
                    </span>
                    <h2 className="mt-4 font-display text-3xl md:text-4xl text-surface-900">
                        Hoe Het Werkt
                    </h2>

                    <p className="mt-3 text-surface-700 max-w-2xl mx-auto text-lg">
                        Peesential is makkelijk in gebruik. Plaats, richt, en ga.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-8 md:gap-6">
                    {instructionItemProps.map((x, i) =>
                        <InstructionItem
                            key={i + 1}
                            stepCount={i + 1}
                            title={x.title}
                            description={x.description}
                        />)}
                </div>

                <Tip />

            </div>
        </section>
    );
};

interface InstructionItemProps {
    stepCount : number;
    title: string;
    description: string;
}

const instructionItemProps: InstructionItemProps[] = [
    {
        stepCount: 1,
        title: "Plaats & Sluit",
        description: "Druk de rand zachtjes aan om een veilige afdichting tegen je lichaam te creëren.",
    },
    {
        stepCount: 2,
        title: "Richt & Ontspan",
        description: "Richt de tuit van je af. Ontspan en plas natuurlijk.",
    },
    {
        stepCount: 3,
        title: "Spoel & Vouw",
        description: "Spoel met water, vouw op, en stop het terug in het discrete draagtasje.",
    },
];

const InstructionItem = (props : InstructionItemProps) => {
    return (
        <div className="group relative pt-8 h-full">

            <div className="absolute -top-7 left-1/2 -translate-x-1/2 z-10 inline-flex items-center justify-center text-2xl
            w-14 h-14 rounded-full bg-brand-500 text-white font-extrabold ring-4 ring-surface-100 shadow-lg shadow-brand-500/30"
            >
                {props.stepCount}
            </div>

            <div className="h-full bg-white rounded-3xl p-5 pt-10 shadow-sm ring-1 ring-surface-200/80
            transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-900/5">
                <div className="flex items-center justify-center rounded-2xl overflow-hidden bg-brand-50 ring-1 ring-brand-100">
                    <img
                        src={`instructions/Peesential-instructie-stap-${props.stepCount}.png`}
                        alt={`Peesential instructies stap ${props.stepCount}`}
                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-[1.03]"
                        width={400}
                        height={500}
                    />
                </div>

                <h3 className="mt-5 text-lg font-semibold text-surface-900">
                    {props.title}
                </h3>

                <p className="mt-2 text-sm leading-relaxed text-surface-700">
                    {props.description}
                </p>
            </div>
        </div>
    );
};


const Tip = () => {
    return (
        <div className="mt-14 flex items-start gap-3 bg-brand-50 border border-brand-200 rounded-2xl p-5 sm:items-center sm:justify-center sm:text-center">
            <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-brand-500 text-white text-lg">
                💡
            </span>
            <p className="text-sm text-brand-900">
                <strong className="font-semibold">Tip:</strong> Oefen een keer thuis om je zelfverzekerd
                te voelen tijdens je volgende uitje!
            </p>
        </div>
    )
}






